// internal-deps
import { getBridgeSdk, GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";
import { VibrateAmplitudeTypes } from "@swiggy-private/native-bridge";

// constants
import { INCOGNITO_CART_CONSTANTS } from "@cart-client/constants/IncognitoCart";

// interfaces
import { CommonUIWrapperProps } from "@cart-client/interfaces/Cart";
import { isAndroidPlatform } from "@swiggy-private/core-ui";

export const triggerHepticFeedBack = (
    duration = 100,
    amplitude: VibrateAmplitudeTypes = VibrateAmplitudeTypes.LIGHT,
) => {
    getBridgeSdk()
        .vibrate({ duration, amplitude })
        .catch(() => void 0);
};

export const updateStatusBarColor = (isIncognitoCart = false, showAddressWidgetTop = false) => {
    const platform = (GlobalHeaderState.getHeader(SwgyHeaderKeysList.platform) || "").toLowerCase();

    if (!isAndroidPlatform(platform)) {
        getBridgeSdk()
            .changeStatusBarColor({
                style:
                    isIncognitoCart && showAddressWidgetTop
                        ? INCOGNITO_CART_CONSTANTS.COLORS.LIGHT_CONTENT
                        : INCOGNITO_CART_CONSTANTS.COLORS.DEFAULT,
            })
            .catch(() => void 0);
    } else {
        getBridgeSdk()
            .changeStatusBarColor({
                style:
                    isIncognitoCart && showAddressWidgetTop
                        ? INCOGNITO_CART_CONSTANTS.COLORS.INCOGNITO_NUDGE_BG
                        : INCOGNITO_CART_CONSTANTS.COLORS.WHITE,
                statusBarMode: isIncognitoCart && showAddressWidgetTop ? "lightContent" : "default",
                bottomBarMode: "default",
            })
            .catch(() => void 0);
    }
};

export const updateStatusBarCleanup = () => {
    const platform = (GlobalHeaderState.getHeader(SwgyHeaderKeysList.platform) || "").toLowerCase();

    if (!isAndroidPlatform(platform)) {
        getBridgeSdk()
            .changeStatusBarColor({ style: INCOGNITO_CART_CONSTANTS.COLORS.DEFAULT })
            .catch(() => void 0);
    } else {
        getBridgeSdk()
            .changeStatusBarColor({
                style: INCOGNITO_CART_CONSTANTS.COLORS.WHITE,
                statusBarMode: "default",
                bottomBarMode: "default",
            })
            .catch(() => void 0);
    }
};

export const shouldRenderVerticalScrollTextBanner = (
    props: Pick<
        CommonUIWrapperProps,
        "isIncognitoCart" | "cartIncognitoModeXp" | "isCartContentHeader" | "showAddressWidgetTop"
    >,
): boolean => {
    return (
        !!props.isIncognitoCart &&
        !!props.cartIncognitoModeXp &&
        !!props.isCartContentHeader &&
        !!props.showAddressWidgetTop
    );
};
